export default "__VITE_PUBLIC_ASSET__fae4324f__"